module.exports = __webpack_public_path__ + "img/0x4a436073552044D5f2f49B176853ad3Ad473d9d6.4918c606.png";